<template>
  <v-data-table
      v-model="selected"
      color="blue lighten-4"
      item-key="movimento.id"
      :headers="headers"
      :items="movimentiSorted"
      :options.sync="options"
      :server-items-length="totaleMovimenti"
      :loading="loading"
      class="elevation-1"
      :disable-sort="true"
      :footer-props="{
        itemsPerPageOptions: [5, 10, 15, 50, 100]
      }"
      @update:options="getDataFromApi"
    >
    <template v-slot:[`item.data`]="{ item }">
      {{ item.data | dateTime }}
    </template>
<!--     <template v-slot:[`item.actions`]="{ item }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon small class="mr-2" @click="editItem(item)" v-bind="attrs" v-on="on">mdi-pencil</v-icon>
        </template>
        <span>Modifica il movimento</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon small @click="deleteItem(item)" v-bind="attrs" v-on="on">mdi-delete</v-icon>
        </template>
        <span>Cancella il movimento</span>
      </v-tooltip>
    </template> -->
    <template v-slot:no-data>
      <v-btn color="primary" @click="getDataFromApi">Ricarica</v-btn>
    </template> 
    </v-data-table>
</template>

<script>
  import { dynamicSortMultiple } from '@/components/helpers.js'
  import movimenti from '@/services/movimentiService.js'
  import configurazioni from '@/services/configurazioniService.js'
  import _ from 'lodash'

  /* eslint-disable */
  export default {
    props: {
      item: Object,
      refresh: Number
    },
    data: () => ({
        totaleMovimenti: 0,
        movimenti: [],
        selected: [],
        loading: true,
        options: {},
        headers: [
          { text: 'Data', value: 'data', align: 'start'},
          { text: 'Codice', value: 'prodotto.codice', align: 'start'},
          { text: 'Magazzino', value: 'magazzino' },
          { text: 'Quantità', value: 'quantita' },
          { text: 'Valore', value: 'valore' },
          { text: 'Causale', value: 'causale' },
          { text: 'Tipo', value: 'riferimento.tipo' },
          { text: 'Riferimento', value: 'riferimento.id' }
        ],
        filtri: null,
        causali: []
    }),
    watch: {
      async refresh() {
        await this.getDataFromApi()
      }
    },
    async mounted() {   
      const backoffice = await configurazioni.getConfigurazione('backoffice', 'impostazioni')
      this.causali = _.get(backoffice, 'prodotti.storico.causaliMovimenti', ['acquisti', 'vendite'])
      await this.getDataFromApi()
    },
    computed: {
      movimentiSorted() {
        return this.movimenti
        /*         const els = this.movimenti
        const elSorted = els.sort(dynamicSortMultiple('_id'))
        return elSorted */
      }   
    },
    methods: {
      async getDataFromApi () {
        try {
          this.loading = true
          // passo periodo e causali da considerare
          this.filtri = {}
          this.filtri.prodotto = this.item._id // solo il prodotto passato
          // console.log(this.filtri.prodotto)
          this.filtri.causale = [...this.causali]
          const data = await movimenti.getMovimentiProdottoFisso(this.filtri, this.options)
          this.movimenti = data && data.total_rows > 0 ? data.rows : []
          this.totaleMovimenti = data.total_rows
        } catch(err) {
          this.movimenti = []
          this.totaleMovimenti = 0
        } finally {
          this.loading = false
        }
      }
    
    }
  }
</script>
